<template>
  <div id="boxLogin">
    <form @submit.prevent="onSubmit()">
      <div
        class="boxError th"
        :class="{ 'shake animated': animated, boxSuccess: !textError }"
        @animationend="animated = false"
        v-if="textError"
      >
        {{ textError }}
      </div>
      <div id="boxEmail">
        <label
          class="is-size-5 has-text-weight-semibold is-flex is-margin-bottom"
          >{{ $t("signin.labelFirst") }}</label
        >
        <b-field label="" class="label-Left reveal">
          <b-input
            :placeholder="$t('signin.placeholderEmail')"
            icon-pack="mdi"
            icon="email"
            v-model="email"
          ></b-input>
        </b-field>
      </div>
      <div id="boxPassWord">
        <label
          class="is-size-5 has-text-weight-semibold is-flex is-margin-bottom"
          >{{ $t("signin.labelSecond") }}</label
        >
        <b-field label="" class="label-Left reveal">
          <b-input
            :placeholder="$t('signin.placeholderPassword')"
            type="password"
            password-reveal
            icon-pack="mdi"
            icon="lock"
            v-model="password"
          ></b-input>
        </b-field>
      </div>
      <div class="label-right" id="boxForgot">
        <router-link to="/forgotpassword" class="is-size-6 forgotText">{{
          $t("signin.forgotPassword")
        }}</router-link>
      </div>
      <div
        class="is-flex is-justify-center is-align-center is-flex-medium boxBtnSignIn"
      >
        <button class="button is-btn-link is-size-6 forgotText" type="submit">
          {{ $t("signin.signinButton") }}
        </button>
      </div>
      <div
        class="is-flex th is-justify-center is-align-center is-flex-medium boxBtnSignIn"
      >
        <p class="mg-t-40 text-grey font-14">
          {{ $t("signin.version") }}
        </p>
      </div>
    </form>
    <!-- <div id="boxSignUp">
       <p>Don't have a account? <router-link to="/signup">Sign up</router-link></p>
    </div>-->

    <b-modal
      :active.sync="isAddMaindDepartment"
      :width="800"
      @close="[$v.$reset(), logout()]"
      class="modal-over-unset"
    >
      <div class="card border-inside">
        <div class="card-content">
          <div class="content">
            <div class="has-text-left">
              <h1 class="th">
                <span class="has-text-weight-normal is-size-4">{{
                  $t("signin.addDepartmentMain")
                }}</span>
                <span class="is-size-5"
                  >({{ $t("signin.addDepartmentMainDes") }})</span
                >
              </h1>
            </div>

            <div class="columns m-h-auto">
              <div class="column has-text-left">
                <p class="is-size-6 has-text-weight-semibold pd-y-5">
                  {{ $t("signin.departmentMainLabel") }}
                </p>
                <b-field
                  :type="$v.maindDepartmentId.$error == true ? 'is-danger' : ''"
                >
                  <b-select
                    v-model="maindDepartmentId"
                    :placeholder="$t('signin.departmentMainPlaceholder')"
                    expanded
                  >
                    <option
                      :value="item._id"
                      v-for="item in dataDepartment"
                      :key="item.id"
                    >
                      {{ item.name }}
                    </option>
                  </b-select>
                </b-field>
              </div>
            </div>
            <div class="columns m-h-auto">
              <div class="column has-text-left">
                <p class="is-size-6 has-text-weight-semibold pd-y-5">
                  {{ $t("signin.departmentLabel") }}
                </p>
                <b-field
                  :type="$v.sciencePark.$error == true ? 'is-danger' : ''"
                  class="label-Left"
                >
                  <b-autocomplete
                    icon-pack="fas"
                    class="th has-text-left"
                    v-model="sciencePark"
                    @input="$v.sciencePark.$touch()"
                    @select="
                      (option) =>
                        option !== null ? (scienceParkId = option._id) : ''
                    "
                    :placeholder="$t('signin.departmentPlaceholder')"
                    :open-on-focus="true"
                    :data="filterOrganizeName"
                    field="name"
                  ></b-autocomplete>
                </b-field>
              </div>
            </div>

            <div class="columns m-h-auto is-vcentered">
              <div class="column has-text-centered">
                <button
                  @click="addDepartmentName()"
                  class="button btn-modal is-margin-left mg-10"
                  slot="trigger"
                >
                  <span class="text-modal pd-x-20">{{
                    $t("signin.btnAdd")
                  }}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>
<script>
import { HTTP } from "../axios.js";
import {
  required,
  minLength,
  sameAs,
  between,
  numeric,
  email,
  helpers,
} from "vuelidate/lib/validators";

export default {
  validations: {
    maindDepartmentId: {
      required,
    },
    sciencePark: {
      required,
    },
  },
  data() {
    return {
      email: "",
      password: "",
      textError: "",
      animated: false,
      isAddMaindDepartment: false,
      maindDepartment: "",
      sciencePark: "",
      scienceParkId: "",
      maindDepartmentName: null,
      maindDepartmentId: null,
      dataOrganization: [],
      dataDepartment: [],
      departmentNameId: "",
    };
  },
  computed: {
    filterOrganizeName() {
      return this.dataOrganization.filter((option) => {
        return (
          typeof option.name !== "undefined" &&
          option.name.toString().toLowerCase().indexOf(this.sciencePark) >= 0 &&
          this.maindDepartmentId === option.underId
        );
      });
    },
    filterDepartmentName() {
      return this.dataDepartment.filter((option) => {
        return (
          typeof option.name !== "undefined" &&
          option.name
            .toString()
            .toLowerCase()
            .indexOf(this.maindDepartmentName) >= 0
        );
      });
    },
    user() {
      return this.$store.getters.user;
    },
    token() {
      return this.$store.state.token;
    },
  },
  created() {
    this.$store.commit("setSpaPage", null);
  },
  mounted() {
    this.getOrganization();
    this.getDepartment();
  },
  methods: {
    addDepartmentName() {
      this.$v.$touch();
      if (this.$v.$invalid) {
      } else {
        let data = {
          underId: this.maindDepartmentId,
          scienceParkId: this.scienceParkId,
          scienceParkName: this.sciencePark,
        };

        HTTP.defaults.headers.common.Authorization = `Bearer ${this.token}`;
        HTTP.post("/api/update/admin/under", data)
          .then((res) => {
            //console.log("/api/update/admin/under", res);
            if (res.data.success) {
              this.changPage(80);
            } else {
              this.$buefy.dialog.alert(
                '<p class="has-text-centered is-size-5">ระบบขัดข้อง กรุณาลองใหม่อีกครั้ง</p>'
              );
            }
          })
          .catch((e) => {
            console.log("/api/update/admin/under/error", e);
            this.$buefy.dialog.alert(
              '<p class="has-text-centered is-size-5">เครือขายไม่เสถียร กรุณาลองใหม่</p>'
            );
          });
      }
    },
    logout() {
      this.$router.push("/signin");
      this.$store.dispatch("logout").then(() => {
        setTimeout(() => {
          window.localStorage.clear();
        }, 100);
        this.$store.commit("resetState");
        window.localStorage.removeItem("vuex");
        delete HTTP.defaults.headers.common.Authorization;
      });
    },
    getOrganization() {
      HTTP.post("/get/all/science/park").then((res) => {
        this.dataOrganization = res.data.obj;
        //console.log("/get/all/science/park", res.data);
      });
    },
    getDepartment() {
      HTTP.post("api/get/all/under").then((res) => {
        this.dataDepartment = res.data.obj;
      });
    },
    onSubmit() {
      this.$store.dispatch("logout").then(() => {
        setTimeout(() => {
          window.localStorage.clear();
        }, 100);
        this.$store.commit("resetState");
        window.localStorage.removeItem("vuex");
        delete HTTP.defaults.headers.common.Authorization;
      });

      const data = {
        email: this.email,
        password: this.password,
      };
      HTTP.post("/api/user/signin", data)
        .then((result) => {
          //console.log("/api/user/signin", result);
          if (result.status === 200) {
            if (result.data.success === false) {
              this.animated = true;
              // if (result.data.data === "email is not active.") {
              //   this.textError =
              //     "กรุณายืนยันที่อยู่อีเมลเพื่อเปิดใช้ระบบ inteGreat";
              // }
              if (
                result.data.data ===
                "email is deActive please contract your staff."
              ) {
                this.textError =
                  "ขณะนี้บัญชี inteGreat ของคุณถูกระงับการใช้งาน กรุณาติดต่อเจ้าหน้าที่";
              } else {
                this.textError =
                  "อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณากรอกใหม่อีกครั้ง";
              }
            } else {
              this.textError = null;
              this.animated = false;

              this.$store.commit("addUser", result.data.item);
              if (result.data.item.userLevel === 80) {
                var level = "admin";
                this.$store.commit("setRule", level);
              } else if (result.data.item.userLevel === 50) {
                var level = "staff";
                this.$store.commit("setRule", level);
              } else if (result.data.item.userLevel === 99) {
                var level = "specialadmin";
                this.$store.commit("setRule", level);
              } else if (result.data.item.userLevel === 85) {
                var level = "board";
                this.$store.commit("setRule", level);
              } else if (result.data.item.userLevel === 90) {
                var level = "exclusiveboard";
                this.$store.commit("setRule", level);
              } else {
                var level = "startup";
                this.$store.commit("setRule", level);
              }

              this.$store.commit("setToken", result.data.token);
              HTTP.defaults.headers.common.Authorization = `Bearer ${result.data.token}`;

              if (
                result.data.item.userLevel === 80 &&
                (result.data.item.under === "" ||
                  result.data.item.under === null)
              ) {
                this.isAddMaindDepartment = true;
              } else {
                this.changPage(result.data.item.userLevel);
              }
            }
          }
        })
        .catch((e) => {
          console.log("/api/user/signin/error", e);
          if (!e.response || e.response != undefined) {
            // network error
            this.textError =
              "Cannot connect to server. Please contact the system administrator.";
            if (e.response.status === 404) {
              this.textError = "Server in maintenance";
            } else if (e.response.status === 405) {
              this.textError =
                "อีเมลหรือรหัสผ่านไม่ถูกต้อง กรุณากรอกใหม่อีกครั้ง";
            } else {
              this.textError = e.response.data.message;
            }
          } else {
            this.textError = e.response.data.message;
          }
        });
    },
    changPage(level) {
      if (level === 99) {
        this.$router.push("/dashboard");
        //console.log("result.data.item.userLevel === 99");
      } else if (level === 85) {
        this.$router.push("/dashboard");
        //console.log("level", level);
      } else if (level === 90) {
        this.$router.push("/dashboard");
        //console.log("level", level);
      } else {
        //console.log("else");
        this.$router.push("/batch/view");
      }
    },
  },
};
</script>
<style>
.boxError {
  border: 1px solid red;
  color: red;
  padding: 20px;
  text-align: center;
  background: #f7d0d0;
}
.boxSuccess {
  border: 1px solid #3c763d !important;
  color: #3c763d !important;
  background: #dff0d8 !important;
}
#boxLogin {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
@media only screen and (max-width: 1024px) {
  .box {
    box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1), 0 0 0 0px rgba(10, 10, 10, 0.1);
    -webkit-box-shadow: 0 0px 0px rgba(10, 10, 10, 0.1),
      0 0 0 0px rgba(10, 10, 10, 0.1);
  }
}
@media (min-width: 1024px) {
  #boxLogin {
    margin-left: 17rem;
    margin-right: 17rem;
  }
}
#boxForgot {
  margin-top: 5px;
}
.forgotText {
  text-align: right;
  font-size: 1rem !important;
  color: #6d8df3;
  margin-top: 0.5rem;
}
#boxEmail {
  margin-top: 1.5rem;
}
#boxPassWord {
  margin-top: 1.5rem;
}
.boxBtnSignIn {
  margin-top: 1.5rem;
  margin-bottom: 1.5rem;
}
#boxSignUp {
  margin-bottom: 2rem;
}
button {
  font-family: "Raleway", sans-serif !important;
}
.animated {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}

.animated.infinite {
  -webkit-animation-iteration-count: infinite;
  animation-iteration-count: infinite;
}
.uat-boder {
  border: 1px solid #ac1818;
  border-radius: 5px;
  margin-top: 30px;
  margin-bottom: 30px;
}
@-webkit-keyframes shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

@keyframes shake {
  from,
  to {
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0);
  }

  10%,
  30%,
  50%,
  70%,
  90% {
    -webkit-transform: translate3d(-10px, 0, 0);
    transform: translate3d(-10px, 0, 0);
  }

  20%,
  40%,
  60%,
  80% {
    -webkit-transform: translate3d(10px, 0, 0);
    transform: translate3d(10px, 0, 0);
  }
}

.shake {
  -webkit-animation-name: shake;
  animation-name: shake;
}
</style>
